<template>
  <v-container>

    <stock-result
        v-if="done"
        :add-transaction="addTransaction"
    />

    <v-row v-else>
      <v-col v-for="(item,index) in getItems" :key="index" cols="12" md="4">
        <product-stock
            :product="item.product"
            v-model="item.add"
            :in-stock="item.quantity"
            :minimum="item.minimum"
        >
        </product-stock>
      </v-col>
      <v-col cols="12" class="text-right">
        <submit-button :disabled="!isReady || submitting" @click="addStock"></submit-button>

      </v-col>
    </v-row>

  </v-container>

</template>

<script>
import ProductStock from "@/modules/delivery/components/ProductStock/ProductStock";
import {SubmitButton} from '@dracul/common-frontend'
import StockOperationProvider from "@/modules/delivery/providers/StockOperationProvider";
import StockResult from "@/modules/delivery/pages/stock/StockOperationPage/StockResult/StockResult";

export default {
  name: "StockAdd",
  components: {StockResult, ProductStock, SubmitButton},
  props: {
    stock: Object,
  },
  data() {
    return {
      items: [],
      addTransaction: null,
      submitting: false,
      clientMutationId: null,
      done: false
    }
  },
  computed: {
    getItems() {
      return this.stock.items.filter(i => i.hide === false)
    },
    getAddItems() {
      return this.stock.items.filter(i => i.add > 0).map(i => ({product: i.product.id, quantity: i.add}))
    },
    isReady() {
      return this.itemsToAdd > 0
    },
    itemsToAdd() {
      return this.stock.items.reduce((a, i) => (a + (i.add || 0)), 0)
    },
  },
  created() {
    this.clientMutationId = this.createClientMutationId()
  },
  methods: {

    addStock() {
      if (this.submitting || this.itemsToAdd === 0) {
        return
      }

      this.submitting = true
      StockOperationProvider.addStockOperation(this.stock.id, this.getAddItems, null, this.clientMutationId)
          .then(r => {
            console.log(r.data.addStockOperation)
            this.addTransaction = r.data.addStockOperation
            this.done = true
            this.$emit('stockAdded')
          })
          .finally(() => {
            this.submitting = false
          })
    },
    createClientMutationId() {
      return [
        'add-stock',
        this.stock.id,
        Date.now(),
        Math.random().toString(36).slice(2)
      ].join('-')
    }
  }
}
</script>

<style scoped>

</style>
